export default __webpack_public_path__ + "static/media/BG_2_02.d9858f25.jpg";